import { alpha, createTheme, darken } from "@mui/material/styles";

import {
  alertSuccess,
  alertError,
  alertWarning,
  alertInfo,
  boxShadow,
  boxShadowHover,
  mainThemeColours,
} from "Constants/ColourConstants";
import { DEFAULT_FONT_FAMILY, BUTTON_MIN_HEIGHT, MODES } from "Constants/theme";

// Theme
import {
  getMuiButtonRootStyles,
  getMuiDisabledStyles,
  muiSnackbarDefaultProps,
} from "./common";

const appTheme = createTheme({
  palette: {
    primary: { main: mainThemeColours.primary[MODES.LIGHT] },
    secondary: { main: mainThemeColours.secondary[MODES.LIGHT] },
    error: { main: mainThemeColours.error[MODES.LIGHT] },
    background: {
      default: mainThemeColours.background[MODES.LIGHT],
      paper: mainThemeColours.paper[MODES.LIGHT],
      elevated: mainThemeColours.elevated[MODES.LIGHT],
    },
  },
  typography: {
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        standardSuccess: { backgroundColor: alertSuccess },
        standardError: { backgroundColor: alertError },
        standardWarning: { backgroundColor: alertWarning },
        standardInfo: { backgroundColor: alertInfo },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: getMuiButtonRootStyles,
        contained: ({ theme }) => ({
          minHeight: BUTTON_MIN_HEIGHT,
          backgroundColor: mainThemeColours.secondary[MODES.LIGHT],
          boxShadow,
          "&:hover": {
            boxShadow: boxShadowHover,
            backgroundColor: darken(
              mainThemeColours.secondary[MODES.LIGHT],
              0.08
            ),
          },
          ...getMuiDisabledStyles(theme),
        }),
        outlined: ({ ownerState }) => {
          const isError = ownerState.color === "error";
          const buttonColor = isError
            ? mainThemeColours.error[MODES.LIGHT]
            : mainThemeColours.primary[MODES.LIGHT];

          return {
            minHeight: BUTTON_MIN_HEIGHT,
            boxShadow,
            borderWidth: 1,
            borderStyle: "solid",
            color: buttonColor,
            borderColor: buttonColor,
            backgroundColor: mainThemeColours.paper[MODES.LIGHT],
            "&:hover": {
              boxShadow: boxShadowHover,
              borderColor: buttonColor,
              backgroundColor: alpha(buttonColor, 0.06),
            },
          };
        },
      },
    },
    MuiSnackbar: {
      defaultProps: muiSnackbarDefaultProps,
    },
  },
});

export default appTheme;
